import React, { Component } from "react";
import { Clock, Users, Calendar } from "lucide-react";
import Countdown from "react-countdown";
import i18n from "../../i18n";

class HeaderRowGrp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            now: new Date().toLocaleString("en-US", { timeZone: "Asia/Riyadh" })
        };
    }



    render() {



        const FinishBid = () => (
            <span className="text-danger">{i18n.t("time_ends")}</span>
        );
        const renderer = ({ days, hours, minutes, seconds, completed }) => {
            if (completed) {
                return <FinishBid />;
            } else {
                let warning =
                    days === 0 && hours === 0 && minutes === 0 && seconds < 10 ? true : false;
                console.log(warning);
                return (
                    <span
                        className={
                            warning
                                ? "text-danger countdown-listing-pg countdwn-warning"
                                : "text-info countdown-listing-pg"
                        }
                    >
                        {days}
                        {i18n.t("D")} : {hours}
                        {i18n.t("H")} : {minutes}
                        {i18n.t("M")} : {seconds}
                        {i18n.t("S")}
                    </span>
                );
            }
        };

        return (


            <div className="modern-reg-tabs">
                <style jsx>{`
          .modern-reg-tabs {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0;
            margin: 0 auto;
            // max-width: 1000px;
            // background: white;
            // border-radius: 20px;
            // box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
            overflow: hidden;
            // border: 1px solid #e2e8f0;
            position: relative;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          }

          // .modern-reg-tabs::before {
          //   content: '';
          //   position: absolute;
          //   top: 0;
          //   left: 0;
          //   right: 0;
          //   height: 4px;
          //   background: linear-gradient(135deg, #189397 0%, #6fd6d4 50%, #189397 100%);
          // }

          .reg-tab-item {
            flex: 1;
            padding: 0.5rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 1rem;
            position: relative;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            min-height: 120px;
            justify-content: center;
          }

          .reg-tab-item:hover {
            // background: linear-gradient(135deg, #189397 0%, #4fc1c0 100%);
            transform: translateY(-2px);
          }

          .reg-tab-item:not(:last-child)::after {
            content: '';
            position: absolute;
            right: 0;
            top: 20%;
            bottom: 20%;
            width: 1px;
            background: linear-gradient(to bottom, transparent, white, transparent);
          }

          .reg-tab-inner-item {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background: linear-gradient(135deg, white 0%, white 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 8px 25px rgba(70, 178, 181, 0.35);
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            position: relative;
            overflow: hidden;
          }

          .reg-tab-inner-item::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, transparent 50%);
            border-radius: 50%;
          }

          .reg-tab-item:hover .reg-tab-inner-item {
            transform: scale(1.1);
            box-shadow: 0 12px 35px rgba(102, 126, 234, 0.4);
          }

          .icon {
            color: white;
            filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
          }

          .sa-details {
            margin: 0;
            text-align: center;
            color: #334155;
            font-weight: 600;
            font-size: 0.9rem;
            line-height: 1.5;
            max-width: 180px;
          }

          .label-text {
            color: white;
            font-size: 0.8rem;
            font-weight: 500;
            // margin-bottom: 0.25rem;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .value-text {
            color: white;
            font-size: 1rem;
            font-weight: 700;
          }

          .countdown-text {
            background: linear-gradient(135deg, #189397, #46b2b5);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            font-weight: 700;
            font-size: 1rem;
          }

          /* Enhanced mobile responsiveness */
          @media (max-width: 768px) {
            .modern-reg-tabs {
              margin: 1rem;
              font-size: 0.4rem;
              border-radius: 16px;
            }

            .reg-tab-item {
              padding: 1.25rem;
              min-height: auto;
              width: 100%;
             
            }

            .reg-tab-item:not(:last-child)::after {
              display: none;
            }

            .reg-tab-item:not(:last-child) {
              border-bottom: 1px solid #e2e8f0;
            }

            .reg-tab-inner-item {
              width: 50px;
              height: 50px;
            }

            .sa-details {
              font-size: 0.85rem;
              max-width: none;
            }
          }

          @media (max-width: 480px) {
            .modern-reg-tabs {
              margin: 0.5rem;
            }

            .reg-tab-item {
              text-align: center;
              padding: 1rem;
              gap: 1rem;
              
            }
            .label-text{
            text-align: center;
                font-size: 0.4rem;
            }
                .value-text{
                font-size: 0.6rem;
                text-align: center;
                }
            .reg-tab-inner-item {
              width: 45px;
              height: 45px;
              flex-shrink: 0;
            }

            .sa-details {
              text-align: left;
              margin: 0;
            }
          }

          /* Animation for count up effect */
          .count-animation {
            animation: countUp 0.8s ease-out;
          }

          @keyframes countUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          /* Pulse animation for active countdown */
          .reg-tab-item:nth-child(2) .reg-tab-inner-item {
            animation: pulse 2s infinite;
          }

          @keyframes pulse {
            0%, 100% {
              box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
            }
            50% {
              box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);
            }
          }

          /* Subtle gradient overlay */
          .modern-reg-tabs::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: radial-gradient(circle at 50% 0%, rgba(102, 126, 234, 0.02) 0%, transparent 50%);
            pointer-events: none;
          }
        `}</style>

                <div className="reg-tab-item">
                    <div className="reg-tab-inner-item">
                        <Calendar size={24} className="icon text-black" />
                    </div>
                    <div className="sa-details">
                        <div className="label-text">{i18n.t("reg_start")}</div>
                        <div className="value-text">
                            {new Date(this.props.reg_start_date) < new Date()
                                ? i18n.t('registration_started')
                                : this.props.reg_start_date}
                        </div>
                    </div>
                </div>

                <div className="reg-tab-item">
                    <div className="reg-tab-inner-item">
                        <Clock size={24} className="icon text-black" />
                    </div>
                    <div className="sa-details">
                        <div className="label-text">{i18n.t("reg_end")}</div>
                        <div className="value-text">
                            {/* <MockCountdown /> */}
                            {(
                                <Countdown
                                    date={new Date(this.props.endTime)}
                                    renderer={renderer}
                                    now={() => new Date()}
                                />)}
                        </div>
                    </div>
                </div>

                <div className="reg-tab-item">
                    <div className="reg-tab-inner-item">
                        <Users size={24} className="icon text-black" />
                    </div>
                    <div className="sa-details">
                        <div className="label-text">{i18n.t("enrolled_users")}</div>
                        <div className="value-text count-animation">
                            {this.props.enrolledUsers}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default HeaderRowGrp;